import React, { useState, useMemo } from 'react';
import SportBettingData from './SportBettingData';
import LineMovementChart from '../../../charts/LineMovementChart';

const LinesView = ({game, sport, homeTeamLabel, awayTeamLabel}) => {
    const [selectedPeriod, setSelectedPeriod] = useState('full');
    const [selectedBetType, setSelectedBetType] = useState('totals');

    const odds = useMemo(() => {
        let betKey = '';
        if(sport === 'mlb' && selectedBetType === 'spread'){
            betKey = 'runline';
        }else{
            betKey = selectedBetType;
        }
    
        return (
            selectedPeriod === 'full'
              ? game?.[betKey]
              : game?.[selectedPeriod]?.[betKey]
          ) ?? null;
    }, [game, selectedPeriod, selectedBetType]);

    return (
        <>
            {/* Betting Lines */}
            <div className="w-full 2xl:max-w-7xl">
                <SportBettingData game={game} sport={sport} period={selectedPeriod} betType={selectedBetType} setPeriod={setSelectedPeriod} setBetType={setSelectedBetType} />
            </div>
            
            {/* Line Movement Charts */}
            {selectedBetType === 'ml' && (
                <div className="flex flex-col xl:flex-row gap-6 max-w-7xl">
                    <div className="flex-1">
                        <LineMovementChart odds={odds} sport={sport} betType={selectedBetType} team={homeTeamLabel} homeAway="home" />
                    </div>
                    <div className="flex-1">
                        <LineMovementChart odds={odds} sport={sport} betType={selectedBetType} team={awayTeamLabel} homeAway="away" />
                    </div>
                </div>
            )}
            {selectedBetType === 'totals' && (
                <div className="max-w-7xl">
                    <LineMovementChart odds={odds} sport={sport} betType={selectedBetType}/>
                </div>
            )}

            {selectedBetType === 'spread' && (
                <div className="flex flex-col xl:flex-row gap-6 max-w-7xl">
                    <div className="flex-1">
                        <LineMovementChart odds={odds} sport={sport} betType={selectedBetType} team={homeTeamLabel} homeAway="home" />
                    </div>
                    <div className="flex-1">
                        <LineMovementChart odds={odds} sport={sport} betType={selectedBetType} team={awayTeamLabel} homeAway="away" />
                    </div>
                </div>
            )}
        </>
    );
};

export default LinesView;